/**
 * Calculates ppf from horizontal resolution and horizontal field of view.
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Object} args.horizontalResolution
 * @param {Number} args.horizontalFieldOfView
 * @return {Number}
 */
import calculateHorizontalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfView'
export default function calculatePpf({ horizontalResolution, horizontalFieldOfView, model, distance }) {
  if (model && model.is_fisheye) {
    horizontalFieldOfView = calculateHorizontalFieldOfView({ horizontalAngleOfView: 180, distance })
  }
  return horizontalResolution / horizontalFieldOfView
}



// WEBPACK FOOTER //
// ./src/helpers/calculations/calculatePpf.js